import { ref } from 'vue'
import { isEmptyObject } from '@/common/converter/utils/is-empty-object'

export const useSideFilter = () => {
  const filterListRef = ref([])

  /**
   * query 를 받아 accepted query 를 만족하는 해당 query object 를 반환
   * @param originQuery
   * @returns {{}}
   */
  const getSideFilterQuery = (originQuery) => {
    const ACCEPTED_QUERIES = ['genre', 'price', 'orderby', 'channel']
    const sideFilterQuery = {}

    ACCEPTED_QUERIES.forEach((key) => {
      if (key in originQuery) {
        sideFilterQuery[key] = originQuery[key]
      }
    })

    return sideFilterQuery
  }

  /**
   * query parameter 에 있는 값을 받아
   * mainCode, subCode 외에 사이드 필터가 더 있으면 해당 query object 를 반환
   * mainCode, subCode 밖에 없으면 filter 안에 있는 _default 값을 반환
   * @param originQuery
   * @returns {{[p: string]: string|acorn.TokenType|[number,string,string]|number|*}|{}}
   */
  const getAppendQuery = (originQuery) => {
    const originSideFilter = getSideFilterQuery(originQuery)
    const hasSideFilterFromQuery = !isEmptyObject(originSideFilter)

    if (hasSideFilterFromQuery) {
      return originSideFilter
    }

    return Object.fromEntries(
      filterListRef.value.map((filter) => [filter?.key, filter?._default]),
    )
  }

  return {
    filterListRef,
    getSideFilterQuery,
    getAppendQuery,
  }
}
